import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ClipboardList, Plus, Search } from "lucide-react";
import { errMsg, fmt, useApi, useLoad, useTaxonomy } from "../../lib/api";
import { catMeta } from "../../lib/media";
import { DashLayout, Empty, ErrorBox, Loading, StatusBadge } from "../../components/kit";
import { RequestForm } from "./RequestForm";

export default function CustomerHome() {
  const api = useApi();
  const nav = useNavigate();
  const { catName } = useTaxonomy();
  const { data, loading, error, reload } = useLoad<any[]>("/customer/requests");
  const [creating, setCreating] = useState(false);
  const create = async (v: any) => {
    try {
      const req = await api("post", "/customer/requests", v);
      toast.success("Request saved. Matching providers found.");
      nav(`/customer/requests/${req.id}`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const onTab = (k: string) => (k === "find" ? nav("/directory") : setCreating(false));
  const action = <button className="btn btn-primary" onClick={() => nav("/customer/new")} data-testid="new-request-button"><Plus className="h-4 w-4" aria-hidden />Post a job</button>;
  return (
    <DashLayout title="Customer Dashboard" idPrefix="customer" value="requests" onChange={onTab} action={action}
      tabs={[["requests", "My Requests", ClipboardList], ["find", "Find Services", Search]]}>
      {creating && <div className="mb-8"><RequestForm submitLabel="Create request" onSubmit={create} onCancel={() => setCreating(false)} /></div>}
      <div className="rounded-lg border border-[var(--steel)] bg-white">
        <h2 className="border-b border-[var(--steel-2)] px-4 py-3 font-bold">My Requests</h2>
        {loading && <div className="px-4"><Loading /></div>}
        {error && <div className="p-4"><ErrorBox message={error} onRetry={reload} /></div>}
        {data && data.length === 0 && <div className="p-4"><Empty title="No requests yet">Create one to see matching approved providers.</Empty></div>}
        <ul className="divide-y divide-[var(--steel-2)]">
          {data?.map((r) => {
            const Icon = catMeta(r.category_id).icon;
            return (
              <li key={r.id}>
                <Link to={`/customer/requests/${r.id}`} className="flex items-center gap-3 px-4 py-3 transition-colors hover:bg-[var(--paper)]" data-testid={`customer-request-${r.id}`}>
                  <Icon className="h-6 w-6 shrink-0 text-[var(--blue)]" aria-hidden />
                  <div className="min-w-0 flex-1">
                    <p className="truncate font-semibold">{catName(r.category_id)} – {r.title}</p>
                    <p className="text-xs text-[var(--muted)]">{r.match_count} {r.match_count === 1 ? "Match" : "Matches"} Found · v{r.version}</p>
                  </div>
                  <div className="text-right"><StatusBadge value={r.status} /><p className="mt-1 text-[11px] text-[var(--muted)]">{fmt(r.updated_at)}</p></div>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </DashLayout>
  );
}
